// extracted by mini-css-extract-plugin
export var chatHtmlText = "_tk-2";
export var chatLink = "_tk-0";
export var chatText = "_tk-1";